// import React from "react";
// import { Route, Routes } from "react-router-dom";
// import QualityChecklistExecutionIndex from "../module/QualityChecklistExecution/qualityChecklistExecutionIndex";
// import QualityConfigurationIndex from "../module/QualityConfiguration/qualityConfigurationIndex";

// function QualityModuleRoutes() {
//   return (
//     <Routes>
//       <Route path="procedure/*" element={<QualityChecklistExecutionIndex />} />
//       <Route path="configuration/*" element={<QualityConfigurationIndex />} />
//     </Routes>
//   );
// }

// export default QualityModuleRoutes;

import React from "react";
import { Route, Routes } from "react-router-dom";
import QualityChecklistExecutionIndex from "../module/QualityChecklistExecution/qualityChecklistExecutionIndex";
import QualityConfigurationIndex from "../module/QualityConfiguration/qualityConfigurationIndex";
import ProtectedRoute from "../../components/ProtectedRoute";

function QualityModuleRoutes() {
  return (
    <Routes>
      <Route
        path="procedure"
        element={
          <ProtectedRoute menuKey="QUALITY_EXECUTION">
            <QualityChecklistExecutionIndex />
          </ProtectedRoute>
        }
      />
      <Route
        path="configuration/*"
        element={
          <ProtectedRoute menuKey="QUALITY_CONFIG">
            <QualityConfigurationIndex />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default QualityModuleRoutes;